const PREFIX = "cart-header";

export const CART_HEADER_DATA_TEST_IDS = {
    EXPRESS_LOTTIE: `${PREFIX}-lottie-express`,
    NON_EXPRESS_LOTTIE: `${PREFIX}-lottie-non-express`,
    OTG_LOTTIE: `${PREFIX}-lottie-otg`,
    BOLT_STAMP_LOTTIE: `${PREFIX}-lottie-bolt-stamp`,
    BOLT_OTG_STAMP_LOTTIE: `${PREFIX}-lottie-bolt-otg-stamp`,
    BOLT_LOTTIE: `${PREFIX}-lottie-bolt`,
    BLCK_SAVING_STRIP: `${PREFIX}-blck-saving-strip`,
    HEADER_MAIN_LOTTIE: `${PREFIX}-lottie-main`,
    HEADER_STAMP_LOTTIE: `${PREFIX}-lottie-stamp`,
    TOING_STAMP: `toing-stamp-lottie`,
};
